import { useGraphQLMutation, useGraphQLQuery } from '@betterment/graphql';

import { SendEmailVerificationEmailDocument } from '../graphql/mutation.sendEmailVerificationEmail.generated';
import { UserIsEmailVerificationEligibleDocument } from '../graphql/query.userIsEmailVerificationEligible.generated';

const useEmailVerification = () => {
  const { data, refetch, error: isVerifiedError, loading } = useGraphQLQuery(UserIsEmailVerificationEligibleDocument);
  const [
    sendEmailVerificationEmail,
    { error: sendEmailVerificationEmailError, loading: isSendEmailVerificationEmailLoading },
  ] = useGraphQLMutation(SendEmailVerificationEmailDocument);

  return {
    isVerified: data?.user ? !data.user.isEmailVerificationEligible : undefined,
    refetchIsVerified: refetch,
    sendEmailVerificationEmail,
    loading: loading || isSendEmailVerificationEmailLoading,
    error: isVerifiedError || sendEmailVerificationEmailError,
  };
};

export default useEmailVerification;
